import { render, staticRenderFns } from "./ClientOrdersCard.vue?vue&type=template&id=6c97288e"
import script from "./ClientOrdersCard.vue?vue&type=script&lang=js"
export * from "./ClientOrdersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports